module.exports = __webpack_public_path__ + "static/media/app icon (9).98d9df7a.png";